<template>
  <nav>
    <v-app-bar app absolute dark color="primary" height="120">
      <div class="d-none d-md-flex align-center">
        <v-img
          alt="Logo Orçamento Participativo"
          class="shrink ml-3"
          contain
          src="../assets/logo-orcamento-participativo-branco.svg"
          width="164"
          height="100"
        />
      </div>

      <v-spacer />

      <v-btn class="mr-6" text @click="goToProjects">
        <v-icon left>mdi-map</v-icon>
        Projetos
      </v-btn>

      <v-btn class="mr-6" text @click="toggleDarkMode(darkMode)">
        <v-icon left v-show="!darkMode">mdi-brightness-3</v-icon>
        <v-icon left v-show="darkMode">mdi-brightness-4</v-icon>
        {{ darkMode ? 'Claro' : 'Escuro' }}
      </v-btn>

      <v-dialog persistent v-model="exitConfirmation" width="310">
        <template v-slot:activator="{ on, attrs }">
          <v-btn depressed color="secondary" v-bind="attrs" v-on="on">
            <v-icon left>mdi-power-standby</v-icon>
            Sair
          </v-btn>
        </template>
        <v-card width="310">
          <v-card-title class="title">Deseja realmente sair?</v-card-title>
          <v-col align="right">
            <v-btn
              color="default"
              text
              class="mr-2"
              @click="exitConfirmation = false"
            >
              Não
            </v-btn>
            <v-btn color="success" text class="mr-2" @click.prevent="logOut">
              Sim
            </v-btn>
          </v-col>
        </v-card>
      </v-dialog>
    </v-app-bar>
  </nav>
</template>

<script>
import getLocalStorageDarkMode from '@/utils/getLocalStorageDarkMode';

export default {
  name: 'Navbar',

  components: {},

  data: () => ({
    darkMode: false,
    exitConfirmation: false,
  }),

  methods: {
    async logOut() {
      if (this.exitConfirmation === true) {
        await this.$store.dispatch('logout');
        this.$router.push('/login');
      }
    },
    goToProjects() {
      this.$router.push('/projects');
    },
    toggleDarkMode(value) {
      this.darkMode = !value;
      this.$vuetify.theme.dark = this.darkMode;
      localStorage.setItem('Orcamento:darkMode', this.$vuetify.theme.dark);
    },
  },

  created() {
    this.darkMode = getLocalStorageDarkMode();
    this.$vuetify.theme.dark = this.darkMode;
  },
};
</script>

<style>
#logout-button {
  margin-left: 27px;
  width: 40px;
  height: 40px;
}

#logout-mdi {
  color: #fafafa;
}
</style>
